import { SelectPaginateAsync } from "@/components/atoms/Select";
import UserRoleFilter from "@/components/molecules/UserRoleFilter";
import useLoadOptions from "@/hooks/useLoadOptions";
import CompanyCourseStatus from "@/interfaces/CompanyCourseStatus";
import { ITableFilterComponentProps } from "@/interfaces/Table";
import { FC } from "react";
import { Button, Card, Form } from "react-bootstrap";
import { MultiValue } from "react-select";

const GeneralFilters: FC<ITableFilterComponentProps> = ({
  filters,
  onFiltersChange,
}) => {
  const {
    loadCompanyCourseStatusesOptions,
    loadOrganisationsOptions,
    loadOpcosOptions,
    loadInstructorsOptions,
    loadCompaniesOptions,
  } = useLoadOptions();

  const handleStatusesChange = (status: MultiValue<CompanyCourseStatus>) => {
    onFiltersChange({
      status,
    });
  };

  const handleChangeDate = (key: string, value: any) => {
    onFiltersChange({
      [key]: value,
    });
  };

  const handleClearFilters = () => {
    onFiltersChange({
      status: [],
      companies: [],
      organizations: [],
      opcos: [],
      instructors: [],
      sdrs: [],
      aes: [],
      followUpDate: "",
      startAt: "",
      endAt: "",
      signatureDate: "",
      sendingDate: "",
      agreementDate: "",
      invoiceDate: "",
      paiementDate: "",
    });
    localStorage.removeItem("generalFilters");
  };

  return (
    <Card className="shadow-none shadow-show-xl scrollbar h-100">
      <Card.Body>
        <Form>
          <Form.Group className="mt-n2">
            <Form.Label>Statuts</Form.Label>
            <SelectPaginateAsync
              loadOptions={loadCompanyCourseStatusesOptions}
              getOptionLabel={(option) => option.name}
              getOptionValue={(option) => option.id.toString()}
              value={filters.status}
              onChange={handleStatusesChange}
              isMulti
              isClearable={false}
            />
          </Form.Group>
          <Form.Group className="mt-2">
            <Form.Label className="mb-1 fs--1">Entreprises :</Form.Label>
            <SelectPaginateAsync
              loadOptions={loadCompaniesOptions}
              getOptionLabel={(option) => option.name}
              getOptionValue={(option) => option.id.toString()}
              value={filters.companies}
              isClearable
              isMulti
              onChange={(companies) => onFiltersChange({ companies })}
            />
          </Form.Group>
          <UserRoleFilter
            role="AE"
            source="all"
            value={filters.aes}
            onChange={(aes) => onFiltersChange({ aes })}
          />
          <UserRoleFilter
            role="SDR"
            source="all"
            value={filters.sdrs}
            onChange={(sdrs) => onFiltersChange({ sdrs })}
          />
          <Form.Group className="mt-2">
            <Form.Label>Date de relance</Form.Label>
            <Form.Control
              type="date"
              value={filters.followUpDate}
              onChange={(e) => handleChangeDate("followUpDate", e.target.value)}
            />
          </Form.Group>
          <Form.Group className="mt-2">
            <Form.Label>Date de début de formation</Form.Label>
            <Form.Control
              type="date"
              value={filters.startAt}
              onChange={(e) => handleChangeDate("startAt", e.target.value)}
            />
          </Form.Group>
          <Form.Group className="mt-2">
            <Form.Label>Date de fin de formation</Form.Label>
            <Form.Control
              type="date"
              value={filters.endAt}
              onChange={(e) => handleChangeDate("endAt", e.target.value)}
            />
          </Form.Group>
          <Form.Group className="mt-2">
            <Form.Label className="mb-1 fs--1">Organisme :</Form.Label>
            <SelectPaginateAsync
              loadOptions={loadOrganisationsOptions}
              getOptionLabel={(option) => option.name}
              getOptionValue={(option) => option.id.toString()}
              value={filters.organizations}
              isMulti
              onChange={(organizations) => onFiltersChange({ organizations })}
              isClearable
            />
          </Form.Group>
          <Form.Group className="mt-2">
            <Form.Label className="mb-1 fs--1">Opco :</Form.Label>
            <SelectPaginateAsync
              loadOptions={loadOpcosOptions}
              getOptionLabel={(option) => option.name}
              getOptionValue={(option) => option.id.toString()}
              value={filters.opcos}
              isMulti
              onChange={(opcos) => onFiltersChange({ opcos })}
              isClearable
            />
          </Form.Group>
          <Form.Group className="mt-2">
            <Form.Label>Date d'envoi</Form.Label>
            <Form.Control
              type="date"
              value={filters.sendingDate}
              onChange={(e) => handleChangeDate("sendingDate", e.target.value)}
            />
          </Form.Group>
          <Form.Group className="mt-2">
            <Form.Label>Date d'accord</Form.Label>
            <Form.Control
              type="date"
              value={filters.agreementDate}
              onChange={(e) =>
                handleChangeDate("agreementDate", e.target.value)
              }
            />
          </Form.Group>
          <Form.Group className="mt-2">
            <Form.Label>Date de facture</Form.Label>
            <Form.Control
              type="date"
              value={filters.invoiceDate}
              onChange={(e) => handleChangeDate("invoiceDate", e.target.value)}
            />
          </Form.Group>
          <Form.Group className="mt-2">
            <Form.Label>Date de paiement</Form.Label>
            <Form.Control
              type="date"
              value={filters.paiementDate}
              onChange={(e) => handleChangeDate("paiementDate", e.target.value)}
            />
          </Form.Group>
          <Form.Group className="mt-2">
            <Form.Label className="mb-1 fs--1">Formateur :</Form.Label>
            <SelectPaginateAsync
              loadOptions={loadInstructorsOptions}
              getOptionLabel={(option) => option.fullname}
              getOptionValue={(option) => option.id.toString()}
              value={filters.instructors}
              isMulti
              onChange={(instructors) => onFiltersChange({ instructors })}
              isClearable
            />
          </Form.Group>
          <Form.Group className="mt-2">
            <Button variant="primary" onClick={handleClearFilters}>
              Réinitialisé
            </Button>
          </Form.Group>
        </Form>
      </Card.Body>
    </Card>
  );
};

export default GeneralFilters;
